import {AfterViewInit, Component, OnInit, Renderer2, ViewChild} from '@angular/core';
import {ApiService} from './shared/service/api.service';
import {ApiFunctionName} from './shared/enum/api-function-name.enum';
import {NavigationEnd, Router, RoutesRecognized} from '@angular/router';
import {ModuleUtils} from './module-utils';
import {TranslateService, USE_EXTEND} from '@ngx-translate/core';
import {LanguageService} from './shared/service/language.service';
import {websiteRoutes} from './website/website-routing.module';
import {ApiData} from './shared/model/api-data.model';
import {GAService} from './shared/service/ga.service';
import {EnvironmentService} from './shared/service/environment.service';
import {AppStorage, StorageKey} from './storage'; // AppStorage import edildi
import {Loading} from './utils'; // Loading import edildi
import iziToast from 'izitoast'; // Hata gösterimleri için iziToast

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild('preloader', {static: false}) preloader;
  isWebsite: boolean;

  constructor(private apiService: ApiService,
              private languageService: LanguageService,
              private gaService: GAService,
              private environmentService: EnvironmentService,
              private router: Router,
              private translate: TranslateService,
              private renderer: Renderer2) {
  }

  ngOnInit(): void {
    // 1. Uygulama açılır açılmaz hafızadaki eski token/id'ler ile ön kurulumu yap
    this.setGlobalPublicKeySetup();

    // 2. Sunucudan güncel Public Key'i iste ve interceptor'ı güncelle
    this.initializePublicKey();

    // Mevcut router event dinleyicin aynen kalıyor
    this.router.events.subscribe(e => {
      if (e instanceof RoutesRecognized) {
        const url = e.urlAfterRedirects;

        // Try to find path in website routes
        this.isWebsite = websiteRoutes
          .filter(i => i.path.indexOf(url.substring(1, url.lastIndexOf('/'))) !== -1)
          .length > 0;

        if (!this.isWebsite) {
          ModuleUtils.addSignageClasses(this.renderer);
          return;
        }

        ModuleUtils.removeSignageClasses(this.renderer);
      }
    });
  }

  ngAfterViewInit(): void {
    this.apiService.apiData(ApiFunctionName.GetMenu).subscribe((apiData: ApiData) => {
      this.handleLanguage(apiData);

      this.environmentService.environment = {
        CustomerID: apiData.CustomerID,
        Locale: apiData.Settings.Locale,
        Currency: apiData.Menu.Currency,
      };

      localStorage.setItem(StorageKey.CURRENCY, apiData.Menu.Currency);

      this.preloader.nativeElement.remove();


      let user = AppStorage.getItem(StorageKey.USER);

      if (!user) {
        Loading.show()
          .then(() => this.apiService.getPublicKey())
          .then(publicKeys => {
            AppStorage.setItem(StorageKey.PUBLICKEY, publicKeys);
          })
          .finally(() => {
            this.setGlobalPublicKeySetup();
            Loading.hide();
          });
      }
    });
  }

  /**
   * Sunucudan Public Key alan ve interceptor'ı tazeleyen metod
   */
  private initializePublicKey() {
    Loading.show()
      .then(() => this.apiService.getPublicKey())
      .then((token: string) => {
        if (token) {
          AppStorage.setItem(StorageKey.PUBLICKEY, token);
          this.setGlobalPublicKeySetup();
        }
      })
      .catch((error) => {
        console.error('Public key alınırken hata oluştu:', error);
      })
      .finally(() => {
        this.apiService.initializeAllApis();
        Loading.hide();
      });
  }

  /**
   * jQuery AJAX istekleri için küresel interceptor kurulumu
   */
  private setGlobalPublicKeySetup() {
    const publicKey = AppStorage.getItem(StorageKey.TOKEN) || AppStorage.getItem(StorageKey.PUBLICKEY);
    const customerId = AppStorage.getItem(StorageKey.CUSTOMERID);

    if (publicKey) {
      $.ajaxSetup({
        beforeSend: function(xhr, settings) {
          if (settings.url && settings.url.includes('/LoginAPI/GetToken')) {
            xhr.setRequestHeader('PublicKey', undefined);
            return;
          }

          xhr.setRequestHeader('PublicKey', publicKey);
          xhr.setRequestHeader('App-Origin', 'com.menulux.webstore');
          if (customerId) {
            xhr.setRequestHeader('CustomerID', customerId);
          }
        },
      });
    } else {
      $.ajaxSetup({
        beforeSend: function(xhr) {
          xhr.setRequestHeader('PublicKey', undefined);
        },
      });
    }

    // Global Hata Yakalama (Error Handling) Yönetimi
    $.ajaxSetup({
      statusCode: {
        401: function(error) {
          if (error.responseText === 'User is not found!') {
            iziToast.warning({
              title: 'Uyarı',
              message: 'Kullanıcı bulunamadı!',
              position: 'topRight',
            });
          }
        },
      },
      error: function(jqXHR) {
        if (jqXHR.status === 409) {
          iziToast.error({
            title: 'Hata',
            message: 'Bir çakışma tespit edildi (409).',
            position: 'topRight',
          });
        }
        if (jqXHR.status !== 401) {
          iziToast.error({
            title: 'Hata',
            message: 'Beklenmedik bir hata oluştu.',
            position: 'topRight',
          });
        }
      },
    });
  }

  private handleLanguage(data) {
    this.languageService.translate = this.translate;

    if (data.Languages != null) {
      data.Languages.forEach(language => {
        this.languageService.addLanguage(language);
      });
    }

    this.languageService.checkSetLanguage();
  }
}
